import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import './styles/TeacherListPage.css';
import { FaEye } from 'react-icons/fa';
import moment from 'moment';
import AuthContext from '../context/AuthContext';

const ExtraTimeListPage = () => {
    const { user } = useContext(AuthContext);
    const [branchList, setBranchList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [extraTimeRequests, setExtraTimeRequests] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState('');
    const [selectedStatus, setSelectedStatus] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalData, setTotalData] = useState(0); 
    const navigate = useNavigate();
    const [isSearched, setIsSearched] = useState(false);
    const [searchName, setSearchName] = useState('');
    const [teacher, setTeacher] = useState('');
    const [branchId, setBranchId] = useState(null);
    const [dateMonth, setDateMonth] = useState('');

    // Fetch branch list when component mounts
    useEffect(() => {
        const fetchBranchList = async () => {
            try {
                const response = await api.get('/utils/getBranchList');
                const branches = response.data.data.branchList.map(branch => ({
                    id: branch.branch_id,
                    name: `${branch.branch_code} - ${branch.branch_name}`,
                }));
                setBranchList(branches);
            } catch (error) {
                console.error("Failed to fetch branch list", error);
            }
        };

        const fetchStatusList = async () => {
            try {
                const response = await api.get('/utils/getExtraTimeStatusList');
                const statuses = response.data.data.statusList.map(status => ({
                    id: status.status_id,
                    name: `${status.status_name}`,
                }));
                setStatusList(statuses);
            } catch (error) {
                console.error("Failed to fetch status list", error);
            }
        };

        const fetchTeacher = async () => {
            try {
                const response = await api.post('/teacher/extratime/getTeacher', 
                    {
                        data: {
                            username: user.username
                        }
                    }
                );
                const teacherData = response.data.data;
                setTeacher(teacherData);
                setBranchId(teacherData.branch_id);
                if(branchId != null){
                    setSearchName(teacherData.teacher_name);
                }
            } catch (error) {
                console.error("Failed to fetch teacher data", error);
            }
        };

        fetchStatusList();
        fetchBranchList();
        fetchTeacher();
        
    }, []);

    useEffect(() => {
            setBranchId(teacher.branch_id);
            //setSelectedBranch(teacher.Branch.branch_name);
        }, [teacher]);
    
        useEffect(() => {
            if(branchId){
                setSearchName(teacher.teacher_name);
                setSelectedBranch(teacher.branch_id);
            }
        }, [branchId]);

    useEffect(() => {
        if (isSearched) {
            handleSearch(); 
        }
    }, [currentPage, isSearched]);

    const handleSearch = async () => {
        try {
            const response = await api.post('/teacher/extratime/list', {
                data: [{
                    teacher_name: searchName,   
                    branch_id: selectedBranch,
                    status_id: selectedStatus,
                    dateMonth: dateMonth
                }],
                limit: 50, 
                page: currentPage 
            });
            setExtraTimeRequests(response.data.data.extraTimeList);
            setTotalData(response.data.data.totalCount); 
            setTotalPages(Math.ceil(response.data.data.totalCount / 50)); 

            const totalCount = response.data.data.totalCount;
            
            if (totalCount > 0) {
                setTotalPages(Math.ceil(totalCount / 50));
                if(totalPages < currentPage){
                    setCurrentPage(1);
                }
            } else {
                setCurrentPage(1);
                setTotalPages(1);
            }

            setIsSearched(true);
        } catch (error) {
            console.error("Failed to fetch teachers", error);
        }
    };
    

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prevPage => prevPage + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(prevPage => prevPage - 1);
        }
    };

    const handleViewDetails = (extraTimeId) => {
        navigate(`/teacher/extraTime/detail/${extraTimeId}`);
    };


    return (
        <div className="teachers-page">
            <div className="page-title">Extra Time List</div>
            <div className="form-container">
                <div className="section">
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Teacher Name</label>
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="Enter teacher name"
                                            value={searchName}
                                            readOnly={branchId ? true : false}
                                            onChange={(e) => setSearchName(e.target.value)}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Branch</label>
                                    </td>
                                    <td>
                                        <select
                                            value={selectedBranch}
                                            disabled={branchId ? true : false}
                                            onChange={(e) => setSelectedBranch(e.target.value)}
                                        >
                                            <option value="">Select Branch</option>
                                            {branchList.map(branch => (
                                                <option key={branch.id} value={branch.id}>
                                                    {branch.name}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Status</label>
                                    </td>
                                    <td>
                                        <select
                                            value={selectedStatus}
                                            onChange={(e) => setSelectedStatus(e.target.value)}
                                        >
                                            <option value="">Select Status</option>
                                            {statusList.map(status => (
                                                <option key={status.id} value={status.id}>
                                                    {status.name}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Date Month</label>
                                    </td>
                                    <td>
                                        <input 
                                            type="month"
                                            name="dateMonth"
                                            value={dateMonth} 
                                            onChange={e => setDateMonth(e.target.value)}
                                        />
                                    </td>  
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <button onClick={handleSearch}>Search</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="section">
                    <div className="teachers-list">
                        <table>
                            <thead>
                                <tr>
                                    <th class="no-column">No</th>
                                    <th>Teacher Name</th>
                                    <th>Branch</th>
                                    <th>Request Type</th>
                                    <th>Status</th>
                                    <th>Extra Time Date</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {extraTimeRequests.map((extraTime, index) => (
                                    <tr key={extraTime.extra_time_id}>
                                        <td class="no-column">{index + 1 + (currentPage - 1) * 50}</td>
                                        <td>{extraTime.Teacher.teacher_name}</td>
                                        <td>{extraTime.Teacher.Branch ? extraTime.Teacher.Branch.branch_name : 'Central'}</td>
                                        <td>{extraTime.Type.type} - {extraTime.Type.type_name}</td>
                                        <td>{extraTime.Status.status_name}</td>
                                        <td>{moment(extraTime.extra_time_date).format('DD MMMM YYYY')}</td>
                                        <td>
                                            <FaEye className="action-icon" title="View Details" onClick={() => handleViewDetails(extraTime.extra_time_id)} />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="total-data">
                        <span>Total Data: {totalData}</span>
                    </div>
                    <div className="pagination">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <button onClick={handlePrevPage} disabled={currentPage === 1}>
                                            Prev
                                        </button>
                                    </td>
                                    <td>
                                        <span>Page {currentPage} of {totalPages}</span>
                                    </td>
                                    <td>
                                        <button onClick={handleNextPage} disabled={currentPage === totalPages}>
                                            Next
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExtraTimeListPage;
